import { call, put, takeLatest } from 'redux-saga/effects';
import request from '../../../../utils/request';
import { BACKEND_URL } from '../../../../variables';
import { actions } from './slice';

const {
    getYears,
    getYearsSuccess,
    getYearsError,
    getWeeklyFiles,
    getWeeklyFilesSuccess,
    getWeeklyFilesError,
    getLastWeeklyDate,
    getLastWeeklyDateError,
    getLastWeeklyDateSuccess,
    getSelectedYear,
} = actions;

export function yearsRequest(api = request) {
    return function* () {
        const requestURL = `${BACKEND_URL}/data-coverage/years`;

        const options = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        };
        try {
            const data: object[] = yield call(api, requestURL, options);
            yield put(getYearsSuccess(data));
        } catch (error: any) {
            yield put(getYearsError(error.response));
        }
    };
}

export function weaklyFilesRequest(api = request) {
    return function* (action) {
        const requestURL = `${BACKEND_URL}/data-coverage/${action.payload.year}/weekly-files`;

        const options = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        };
        try {
            const data: object[] = yield call(api, requestURL, options);
            yield put(getWeeklyFilesSuccess(data));
        } catch (error: any) {
            yield put(getWeeklyFilesError(error.response));
        }
    };
}

export function lastWeeklyDateRequest(api = request) {
    return function* () {
        const requestURL = `${BACKEND_URL}/data-coverage/lastWeeklyDate`;

        const options = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        };
        try {
            const data: object[] = yield call(api, requestURL, options);
            yield put(getLastWeeklyDateSuccess(data));
        } catch (error: any) {
            yield put(getLastWeeklyDateError(error.response));
        }
    };
}

export function updateSelectedYear(year) {
    return function* () {
        yield put(getSelectedYear(year));
    };
}

export default function* rootSaga() {
    yield takeLatest(getYears.type, yearsRequest());
    yield takeLatest(getWeeklyFiles.type, weaklyFilesRequest());
    yield takeLatest(getLastWeeklyDate.type, lastWeeklyDateRequest());
    yield takeLatest(getSelectedYear.type, (year) => updateSelectedYear(year));
}
